export default function ({app, error}) {
  if (!app.$companyHasRole('workflow')) {
    return error({
      message: '権限がありません。',
      redirectPath: app.$redirectPathDefault(),
      redirectText: 'メインメニュー'
    });
  }
}
